import styled from 'styled-components';
import {Btn} from '../../elements/button/btn-type/Btn';

export const DrawerBtn = styled.div`
    --drawer-btn-width: 50px;
    position: fixed;
    width: 100vh;
    height: var(--drawer-btn-width);
    right: -50vh;
    top: 50vh;
    z-index: 900;
    transform: rotate(180deg);
    transform: translateX(calc(0px - (var(--drawer-btn-width) / 2))) translateY(-50%) rotate(270deg);

    display: flex;
    justify-content: center;
    pointer-events: none;
    ${Btn} {
        height: var(--drawer-btn-width);
        pointer-events: fill;
        border-radius: 8px 8px 0 0;
        margin: 0 1px;
    }
`;
